// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Zk130","text":"Button_text__hSk4A","leftIcon":"Button_leftIcon__mS6C-","rightIcon":"Button_rightIcon__FA+pn"};